// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-content p.is-empty:first-child::before {\n  content: attr(data-empty-text);\n  float: left;\n  color: #ccc;\n  pointer-events: none;\n  height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
